export default __webpack_public_path__ + "static/media/ezzam-artworkinfo3.81a1f304.png";